import React from 'react';
import { Button } from 'reactstrap';
import { addApplicationUrl } from '../../../../../utils/applicant_tracking/application';

interface PropTypes {
  candidateId: number;
  referralFlow?: boolean;
  onClose: () => void;
}

export function DraftCandidateBody(props: PropTypes) {
  return (
    <>
      <div className='fs-5 mb-6h'>
        This candidate already exists as a draft. Would you like to continue
        creating a job application for them?
      </div>
      <div className='d-flex justify-content-end'>
        <Button className='me-2' color='danger' onClick={props.onClose}>
          Cancel
        </Button>
        <Button
          color='primary'
          onClick={() =>
            (window.location.href = addApplicationUrl(
              props.candidateId,
              props.referralFlow,
            ))
          }
        >
          Continue
        </Button>
      </div>
    </>
  );
}
